<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>
          <el-col :span="20">
            <div class="center-left">
              <el-card style="margin-bottom:10px">
                <el-input
                  v-model="search.project_name"
                  :clearable="true"
                  placeholder="请输入项目名称"
                  size="small"
                  style="width: 200px"
                ></el-input>

                <el-button type="primary" size="small" icon="el-icon-search" @click="doSearch()">搜索</el-button>
              </el-card>
              <WtDataTable
                ref="tablesRef"
                :search="search"
                :listUrl="$db.config.com_project.end.list"
              >
                <template slot="columns">
                  <el-table-column label="项目名称" min-width="230">
                    <template slot-scope="scope">
                      <!-- <a href="JavaScript:;" @click="goDetail(scope.row)"></a> -->
                      {{scope.row.project_name}}
                      <el-tag size="small" v-if="scope.row.if_province === 1">我发起的</el-tag>
                      <div style="color:#666">{{scope.row.regdate_start}}至{{scope.row.regdate_end}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="apply_unit_count" label="申请机构数" align="center" width="100"></el-table-column>
                  <el-table-column prop="node_count" label="已结项机构数" align="center" width="110"></el-table-column>
                  <el-table-column
                    prop="audit_status_text"
                    label="基金会审核意见"
                    align="center"
                    width="140"
                  >
                    <template slot-scope="scope">
                      <span
                        v-if="scope.row.audit_status == 2 "
                        style="color:red;text-decoration: underline; cursor: pointer;"
                      >
                        <el-popover
                          placement="top"
                          title="审核意见："
                          width="200"
                          trigger="click"
                          :content="scope.row.audit_option"
                        >
                          <span slot="reference">{{scope.row.audit_status_text}}</span>
                        </el-popover>
                      </span>

                      <span v-else>{{scope.row.audit_status_text}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" align="center" width="360" fixed="right">
                    <template slot-scope="scope">
                      <el-button-group>
                        <el-button
                          type="primary"
                          icon="el-icon-view"
                          size="mini"
                          @click="lookReport(scope.row)"
                        >查看机构结项报告</el-button>
                        <el-button
                          type="primary"
                          icon="el-icon-edit"
                          size="mini"
                          :disabled="!scope.row.if_option"
                          v-if="Number(scope.row.node_info_id) > 0"
                          @click="editReport(scope.row)"
                        >修改汇总结项报告</el-button>
                        <el-button
                          type="primary"
                          icon="el-icon-edit"
                          size="mini"
                          :disabled="!scope.row.if_option"
                          @click="addReport(scope.row)"
                          v-else
                        >提交汇总结项报告</el-button>
                      </el-button-group>
                    </template>
                  </el-table-column>
                </template>
              </WtDataTable>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-dialog :visible.sync="show_end" width="50%" @close="cancelBtn">
        <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">
          “
          <span style="color:red">{{end_title}}</span>
          ” -- 项目汇总结项报告
        </div>

        <el-form :model="endForm" ref="formRef" label-width="100px" style="width:96%">
          <el-form-item label="结项附件">
            <el-upload
              ref="fileUploads"
              :action="uploadFileUrl"
              :before-upload="beforeUploadFile"
              :file-list="defFiles"
              :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defFiles');
                    }"
              :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defFiles');
                    }"
              :limit="1"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <!-- <a
              v-if="endForm.file_id_path && endForm.file_id_path[0]"
              href="javascript:;"
              @click="downFile(endForm.file_id_path[0].id,endForm.file_id_path[0].name)"
            >点击下载原汇总结项附件</a>-->
            <a
              :href="item.url"
              target="_blank"
              :key="index"
              v-for="(item,index) in endForm.file_id_path"
            >{{item.name}}</a>
          </el-form-item>

          <el-form-item label="备注" prop="remark">
            <el-input v-model="endForm.remark" type="textarea" :rows="4"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="danger" size="small" icon="el-icon-close" @click="cancelBtn">关闭</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-check"
            @click="submitF"
            :loading="loading"
          >提交</el-button>
        </span>
      </el-dialog>

      <!-- <detail v-if="if_open" v-model="if_open" :id="approval_id"></detail> -->
      <report-list v-if="if_open" v-model="if_open" :id="project_id" :title="end_title"></report-list>
      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
// import detail from "../approval/detail";
import reportList from "./report_list";
import baseUrl from "@/config/index";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    reportList
    // detail
  },
  data() {
    return {
      defFiles: [],
      search: { project_name: null },
      loading: false,
      show_end: false,
      end_title: "",
      endForm: {
        id: null,
        file_id: null,
        remark: null,
        file_id_path: [],
        project_before_id: null
      },
      uploadFileUrl: "",

      if_open: false,
      project_id: null
    };
  },
  methods: {
    doSearch() {
      this.$refs["tablesRef"].handleSearch();
    },

    //新增汇总结项信息
    addReport(row) {
      this.endForm.id = null;
      this.endForm.file_id_path = [];
      this.endForm.project_before_id = row.id;
      this.end_title = row.project_name;
      this.show_end = true;
    },

    //编辑汇总报告信息
    editReport(row) {
      this.endForm.file_id_path = [];
      this.endForm.project_before_id = row.id;
      this.end_title = row.project_name;
      this.$db
        .post(this.$db.config.com_project.end.info, { id: row.node_info_id })
        .then(res => {
          this.endForm = res.data;
          this.show_end = true;
        });
    },

    //查看管辖机构的结项报告
    lookReport(row) {
      this.project_id = row.id;
      this.end_title = row.project_name;
      this.if_open = true;
    },

    //上传结项附件
    beforeUploadFile(file) {
      let bool = this.$fnc.checkUploadFile(file);
      return bool;
    },

    //关闭
    cancelBtn() {
      this.$refs.formRef.resetFields();
      this.show_end = false;
    },

    //提交汇总结项报告
    submitF() {
      let arr = [];
      for (const item of this.defFiles) {
        if (item.hasOwnProperty("response")) {
          arr.push(item.response.data.id);
        } else {
          arr.push(item.id);
        }
      }
      this.endForm.file_id = arr[0];
      this.$db
        .post(this.$db.config.com_project.end.url, this.endForm)
        .then(res => {
          this.cancelBtn();
          this.$message.success(res.msg);
          this.$refs.tablesRef.reloadData();
        });
    },

    //下载文件
    downFile(id, name) {
      this.$db
        .downFilePost(this.$db.config.downloadFileUrl, { file_id: id })
        .then(res => {
          if (res.hasOwnProperty("code")) {
            var enc = new TextDecoder("utf-8");
            var result = JSON.parse(enc.decode(new Uint8Array(res)));
            if (result.code !== 200) {
              this.$message.warning(result.msg);
            }
          } else {
            this.download(res, name);
          }
        });
    },
    // 下载文件
    download(data, name) {
      if (!data) {
        return;
      }

      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let alink = document.createElement("a");
      alink.href = url;
      alink.download = name; //文件名
      alink.click();
      this.downConfirm = false;
    },

    //查看结项信息
    getEndInfo(pid) {
      this.$db
        .post(this.$db.config.getProjectEndInfo, { project_id: pid })
        .then(res => {
          if (res && res.code == 200) {
            this.endInfo = res.data;
            this.defFiles = res.data.file_id_path;
          }
        });
    }
  },
  mounted() {
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;
  }
};
</script>
<style lang="less" scoped>
#app-center {
  width: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 1vw;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/end/list.vue